import axios from 'axios';
import type {
  AOEAnswerT,
  LabTestCollectionMethodT,
  LabTestTVitalLabTestMetadataTVitalLabMarkerMetadataT as LabTestT,
  OrderTVitalOrderMetadataTVitalLabTestMetadataTVitalLabMarkerMetadataT as VitalOrderT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export interface SubmitLabOrderSetRequestT {
  name: string;
  description: string;
  collectionMethod: LabTestCollectionMethodT;
  markerIds: string[];
  fasting?: boolean;
  aoeAnswers?: AOEAnswerT[];
  notes?: string;
  priority?: boolean;
  icdCodes?: string[];
}

export interface SubmitLabOrderSetResponseT {
  labTest: LabTestT;
  order: VitalOrderT;
}

export async function fetchSubmitLabOrderSet(
  userId: string,
  request: SubmitLabOrderSetRequestT,
  signal?: AbortSignal
): Promise<SubmitLabOrderSetResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.post<SubmitLabOrderSetResponseT>(
    `/greenfield/care/${userId}/labs/order-sets`,
    request,
    config
  );
  return response.data;
}
